/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import { Modal } from "react-bootstrap";
import { getLogin, getFindPwd, getFindUserId, getBotAdmin } from "../../api";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import LayoutAuth from "./Layout";
/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

function Login(props) {
  // console.log("Login", props);

  const { intl } = props;

  const [loading, setLoading] = useState(false);
  const [isFindId, setIsFindId] = useState(false);
  const [isFindPwd, setIsFindPwd] = useState(false);
  const [isOkSendPwd, setIsOkSendPwd] = useState(false);
  const [isNoSendPwd, setIsNoSendPwd] = useState(false);
  const [isIdRemember, setIsIdRemember] = useState(false);
  const [findPwd, setFindPwd] = useState();
  const [findId, setFindId] = useState();
  const [isOkFindId, setIsOkFindId] = useState(false);
  const [isNoFindId, setIsNoFindId] = useState(false);
  const [waitFind, setWaitFind] = useState(false);
  const [findUser, setFindUser] = useState([]);
  const [botLoginYn, setBotLoginYn] = useState(
    props.location.state ? props.location.state.botLogin : ""
  );
  const [idPlaceHolder, setIdPlaceHolder] = useState();

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  useEffect(() => {
    const idRemember = localStorage.getItem("idRemember") || "";
    // console.log("auth", auth);
    if (idRemember !== "") {
      setInput({
        ...input,
        email: idRemember,
      });
      setIsIdRemember(true);
    }
    if (localStorage.getItem("token")) {
      if (localStorage.getItem("userRole") === "BotAdmin") {
        props.history.push("/licenseList");
      } else {
        props.history.push("/main");
        // props.login(res.token);
      }
    }

    if (botLoginYn === "botLogin") {
      setIdPlaceHolder("Bot ID");
    } else {
      setIdPlaceHolder("Email ID");
    }
  }, []);

  const [input, setInput] = useState({
    email: "",
    password: "",
  });

  const [userInfo, setUserInfo] = useState({
    userName: "",
    nationNum: "82",
    phoneNumber: "",
  });

  const onChange = (event) => {
    setInput({
      ...input,
      [event.target.name]: event.target.value,
    });
  };

  const onUserInfoChange = (event) => {
    setUserInfo({
      ...userInfo,
      [event.target.name]: event.target.value,
    });
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };
  const [isShow, setIsShow] = useState(false);
  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const toggleIdRemember = () => {
    setIsIdRemember(!isIdRemember);
  };

  // 로그인 함수
  const onSubmitLogin = (e) => {
    e.preventDefault();
    //기억하기
    if (isIdRemember) {
      localStorage.setItem("idRemember", input.email);
    } else {
      localStorage.removeItem("idRemember");
    }

    // enableLoading();
    (async function loginFun() {
      // disableLoading();
      let loginType;
      if (input.email === "admin") {
        loginType = "systemAdmin";
      } else if (botLoginYn === "botLogin") {
        loginType = "bot";
      } else {
        loginType = "botAdmin";
      }

      const res = await getLogin(
        {
          loginId: input.email,
          pwd: input.password,
        },
        loginType
      );

      console.log("resres", res);
      if (res.result) {
        // localStorage.clear();
        localStorage.setItem("token", res.token);
        localStorage.setItem("user", res.data);
        localStorage.setItem("userNo", res.data.no);
        localStorage.setItem("userId", res.data.loginId);
        localStorage.setItem("userRole", res.data.role);
        // props.login(res.token);
        console.log("res.data.role", res.data.role);
        if (res.data.role === undefined) {
          localStorage.setItem("userRole", "Bot");
        }

        if (localStorage.getItem("userRole") == "Bot") {
          const botAdmin = await getBotAdmin(res.data.loginId);
          localStorage.setItem("botAdminId", botAdmin.data.loginId);
          localStorage.setItem("botAdminNo", botAdmin.data.no);
        }
        if (res.data.role === "BotAdmin") {
          props.history.push("/licenseList");
        } else {
          props.history.push("/main");
          // props.login(res.token);
        }
      } else {
        alert(res.msg);
        toggleShow();
      }
    })();
    return false;
  };

  const findUserId = async () => {
    const res = await getFindUserId(userInfo);
    // console.log("res", res);
    setIsFindId(false);
    if (res.result) {
      // setFindId(maskEmail(res.data.loginId));
      setFindUser(res.data);
      setIsOkFindId(true);
      setUserInfo({
        ...userInfo,
        userName: "",
        phoneNumber: "",
      });
    } else {
      setIsNoFindId(true);
    }
  };
  const maskEmail = (email) => {
    let split = email.split("@");
    return (
      email.substr(0, 2) +
      new Array(split[0].length - 1).fill("*").join("") +
      "@" +
      split[1]
    );
  };

  const findPassword = async () => {
    setWaitFind(true);

    const res = await getFindPwd(findPwd);
    setIsFindPwd(false);
    setWaitFind(false);
    if (res.result) {
      setIsOkSendPwd(true);
    } else {
      setIsNoSendPwd(true);
    }
  };

  // const getInputClasses = (fieldname) => {
  // 	if (formik.touched[fieldname] && formik.errors[fieldname]) {
  // 		return "is-invalid";
  // 	}

  // 	if (formik.touched[fieldname] && !formik.errors[fieldname]) {
  // 		return "is-valid";
  // 	}

  // 	return "";
  // };

  // const formik = useFormik({
  // 	initialValues: {
  // 		email: "",
  // 		password: "",
  // 	},
  // 	validationSchema: LoginSchema,
  // 	onSubmit: (values, { setStatus, setSubmitting }) => {
  // 		// enableLoading();
  // 		props.onSubmitLogin({ loginId: values.email, pwd: values.password });
  // 		// disableLoading();
  // 		// setSubmitting(false);
  // 	},
  // });

  return (
    <LayoutAuth>
      <div className="login-form login-signin" id="kt_login_signin_form">
        {/* D1: ID 찾기 모달 확인 선택 후 정보가 있을경우 */}
        <Modal show={isOkFindId}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">ID 찾기</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {findUser.length > 0 &&
              findUser.map((data, index) => {
                return <p>{maskEmail(data.loginId)}</p>;
              })}
            {findUser.length === 0 && (
              <p className="mb-0">ID가 존재하지 않습니다.</p>
            )}
            {/* <p className="mb-0">hs****@laidback.co.kr</p> */}
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() => setIsOkFindId(false)}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* D1: ID 찾기 모달 확인 선택 후 정보가 있을경우 */}
        <Modal show={isFindId}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">ID 찾기</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <p>{findId}</p>
            {/* <p className="mb-0">hs****@laidback.co.kr</p> */}
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() => setIsOkFindId(false)}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* D1: ID 찾기 선택 시 */}
        <Modal
          show={isFindId}
          // onHide={toggleShow}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">ID 찾기</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Name</p>
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="name"
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6`}
                name="userName"
                value={userInfo.userName || ""}
                onChange={(e) => onUserInfoChange(e)}
              />
            </div>
            <p>Mobile Phone</p>
            <div className="form-group fv-plugins-icon-container">
              <select
                className="form-control form-control-lg form-control-solid mb-2"
                name="phoneSelet"
                onChange={(e) => onUserInfoChange(e)}
              >
                <option value="82">South Korea +82</option>
              </select>
              <input
                placeholder="Phone Number"
                type="number"
                className={`form-control form-control-solid h-auto py-5 px-6`}
                name="phoneNumber"
                value={userInfo.phoneNumber || ""}
                onChange={(e) => onUserInfoChange(e)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() => setIsFindId(false)}
                className="btn btn-light btn-elevate"
              >
                취소
              </button>
              <> </>
              <button
                type="button"
                disabled={
                  !userInfo.userName.trim() || !userInfo.phoneNumber.trim()
                }
                onClick={findUserId}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* D1: ID 찾기 모달 확인 선택 시 회원 정보를 찾을 수 없을 떄 */}
        <Modal show={isNoFindId}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">ID 찾기</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <h1 className="text-primary mb-5">
              <img
                src={toAbsoluteUrl("/media/bg/popup-undo3x.png")}
                width="40"
                height="40"
              />
            </h1>
            <span>회원 정보가 존재 하지 않습니다.</span>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() => {
                  setIsNoFindId(false);
                  setIsFindId(true);
                  setUserInfo({
                    ...userInfo,
                    userName: "",
                    phoneNumber: "",
                  });
                }}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* D2: Password 찾기 선택 시 */}
        <Modal
          show={isFindPwd}
          // onHide={toggleShow}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              Password 찾기
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>ID</p>
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Email ID"
                type="email"
                className={`form-control form-control-solid h-auto py-5 px-6`}
                name="email"
                value={findPwd}
                onChange={(e) => setFindPwd(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                style={{ marginRight: 5 }}
                type="button"
                onClick={() => {
                  setIsFindPwd(false);
                  setFindPwd("");
                }}
                className="btn btn-light btn-elevate"
              >
                취소
              </button>

              <button
                type="button"
                disabled={!findPwd || waitFind}
                onClick={findPassword}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* D2: Password 찾기 모달 확인 선택 시 */}
        <Modal show={isOkSendPwd}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              Password 찾기
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <p>{findPwd}으로 Password가 발송되었습니다.</p>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() => {
                  setIsOkSendPwd(false);
                  setFindPwd("");
                }}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* D2: Password 찾기 모달 확인 선택 시 ID를 찾을 수 없을 떄 */}
        <Modal show={isNoSendPwd} onHide={toggleShow}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              Password 찾기
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <h1 className="text-primary mb-5">
              <img
                src={toAbsoluteUrl("/media/bg/popup-undo3x.png")}
                width="40"
                height="40"
              />
            </h1>
            <span>ID가 존재 하지 않습니다.</span>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={() => {
                  setIsNoSendPwd(false);
                  setFindPwd("");
                  setIsFindPwd(true);
                }}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal>
        {/* 
        D2: 로그인 시 ID 또는 Password가 잘못 되었을 시
        <Modal show={isShow} onHide={toggleShow}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">로그인</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <h1 className="text-primary mb-5">X</h1>
            <p className="mb-0">Bot 계정정보가 존재하지 않습니다.</p>
            <p className="mb-0">Bot 관리자에게 계정 문의 바랍니다.</p>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button
                type="button"
                onClick={toggleShow}
                className="btn btn-primary btn-elevate"
              >
                확인
              </button>
            </div>
          </Modal.Footer>
        </Modal> */}

        {/* begin::Head */}
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1">로그인</h3>
        </div>
        {/* end::Head */}

        {/*begin::Form*/}
        <form
          onSubmit={onSubmitLogin}
          noValidate={true}
          // className="form fv-plugins-bootstrap fv-plugins-framework"
        >
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder={idPlaceHolder}
              type="email"
              className={`form-control form-control-solid h-auto py-5 px-6`}
              name="email"
              value={input.email || ""}
              onChange={(e) => onChange(e)}
            />
            {/* {formik.touched.email && formik.errors.email ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.email}</div>
              </div>
            ) : null} */}
          </div>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Password"
              type="password"
              className={`form-control form-control-solid h-auto py-5 px-6`}
              name="password"
              value={input.password || ""}
              onChange={(e) => onChange(e)}
            />
            {/* {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.password}</div>
              </div>
            ) : null} */}
          </div>
          <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                className="mr-2"
                checked={isIdRemember}
                onClick={() => toggleIdRemember()}
              />
              <span className="font-weight-bold text-dark-50">ID 기억하기</span>
            </div>
            {!botLoginYn && (
              <div>
                <button
                  className="text-dark-50 text-hover-primary my-3 mr-2"
                  id="kt_login_forgot"
                  onClick={() => setIsFindId(true)}
                  type="button"
                >
                  ID 찾기 |
                </button>
                <button
                  className="text-dark-50 text-hover-primary my-3 mr-2"
                  id="kt_password_forgot"
                  onClick={() => setIsFindPwd(true)}
                  type="button"
                >
                  Password 찾기
                </button>
              </div>
            )}
          </div>
          <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
            {!botLoginYn && (
              <div>
                <span className="font-weight-bold text-dark-50">
                  아직 계정이 없으신가요?
                </span>
                <Link
                  to="/auth/registration"
                  className="font-weight-bold ml-2"
                  id="kt_login_signup"
                >
                  가입하기
                </Link>
              </div>
            )}
            {botLoginYn && <div></div>}
            <div>
              <button
                id="kt_login_signin_submit"
                type="submit"
                disabled={!input.email || !input.password}
                // onSubmit={() => onSubmitLogin()}
                // onClick={() => onSubmitLogin()}
                className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
              >
                <span>로그인</span>
                {/* {loading && <span className="ml-3 spinner spinner-white"></span>} */}
              </button>
            </div>
          </div>
        </form>
        {/*end::Form*/}
      </div>
    </LayoutAuth>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
